import * as React from "react";
import type { SVGProps } from "react";
const SvgImgDisconnect = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0V0z" /><path d="M 18,7 V 4 C 18,2.9 17.1,2 16,2 H 8 C 6.9,2 6,2.9 6,4 V 7 H 5 v 6 l 3,6 v 3 h 8 v -3 l 3,-6 V 7 Z M 7.1864407,3.3898305 16.915254,3.2881356 V 7 H 13.99 V 5 h -1 V 7 H 11 V 5 H 10 V 7 H 7.1864407 Z M 17.915254,12.53 14.813559,18.93678 v 1.876779 L 9.2881356,20.711864 V 18.835085 L 6.1864407,12.631694 V 8.0847458 L 17.915254,8.1864407 Z" style={{
    stroke: "none",
    strokeWidth: 2,
    strokeMiterlimit: 4,
    strokeDasharray: "none"
  }} /></svg>;
export default SvgImgDisconnect;